import { IMarketProduct } from '@/domain/bankwatch';
import { MarketProductsState } from './index';

export const mutations = {
  setAllMarketProducts(state: MarketProductsState, products: IMarketProduct[]) {
    state.allMarketProducts = products;
  },

  setSelectedMarketProduct(state: MarketProductsState, product: IMarketProduct | null) {
    state.selectedMarketProduct = product;
  },

  setIsFetching(state: MarketProductsState, isFetching: boolean) {
    state.isFetching = isFetching;
  },

  setError(state: MarketProductsState, error: string | null) {
    state.error = error;
  }
};
